<template>
  <v-row no-gutter>
    <v-col cols="12">
      <sidebar-row>
        <ribbon-list :listItems="value" :toggleable="false" style-type="defaultHigher">
          <template #default="{ item: element, index: idx }">
            <v-col cols="12" v-if="element.type === 'vertice'">
              <precise-digitizing-summary-vertice
                :value="element"
                :has-add="idx === value.length - 1"
                :has-delete="value.length > 1 && idx !== value.length - 1"
                @input="onInput(idx, $event)"
                @add="onAdd('vertice', idx, $event)"
                @delete="onDelete('vertice', idx)"
              />
            </v-col>
            <v-col cols="12" v-else-if="element.type === 'line'">
              <precise-digitizing-summary-line
                :value="element"
                :has-add="idx === value.length - 1"
                :has-delete="value.length > 1 && idx !== value.length - 1"
                @input="onInput(idx, $event)"
                @add="onAdd('line', idx, $event)"
                @delete="onDelete('line', idx)"
              />
            </v-col>
          </template>
        </ribbon-list>
      </sidebar-row>
    </v-col>
  </v-row>
</template>
<script>
import { get } from 'vuex-pathify';

import PreciseDigitizingSummaryVertice from '@/components/PreciseDigitizingSummaryVertice';
import PreciseDigitizingSummaryLine from '@/components/PreciseDigitizingSummaryLine';
import RibbonList from '@/components/RibbonList';
import SidebarRow from '@/components/SidebarRow';

import { getDestinationCoords } from '@/assets/js/mapUtils';

export default {
  name: 'PreciseDigitizingSummary',
  components: { PreciseDigitizingSummaryVertice, PreciseDigitizingSummaryLine, RibbonList, SidebarRow },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    cursorPositionEpsg: get('map/cursorPositionEpsg'),
  },
  methods: {
    onInput(index, { value } = {}) {
      if (value.type === 'line' && !value.new) {
        const { azimuth = 0, length = 0 } = value;
        if ((azimuth || azimuth === 0) && length) {
          const { coordinateX, coordinateY } = this.value[index - 1];
          const destinationCoords = getDestinationCoords(
            [coordinateX, coordinateY],
            azimuth,
            length,
            this.cursorPositionEpsg
          );
          this.onInput(index + 1, {
            value: {
              coordinateX: Math.round(destinationCoords[0] * 10000000000) / 10000000000,
              coordinateY: Math.round(destinationCoords[1] * 10000000000) / 10000000000,
              type: 'vertice',
            },
          });
        } else {
          this.onInput(index + 1, {
            value: {
              coordinateX: null,
              coordinateY: null,
              type: 'vertice',
            },
          });
        }
      } else {
        this.$set(this.value, index, value);
        this.$emit('input', this.value);
      }
    },
    onAdd(type, index, value) {
      if (type === 'line') {
        const { azimuth, length } = value;
        const { coordinateX, coordinateY } = this.value[index - 1];
        const destinationCoords = getDestinationCoords(
          [coordinateX, coordinateY],
          azimuth,
          length,
          this.cursorPositionEpsg
        );
        this.value.push({
          type: 'vertice',
          coordinateX: Math.round(destinationCoords[0] * 10000000000) / 10000000000,
          coordinateY: Math.round(destinationCoords[1] * 10000000000) / 10000000000,
        });
        this.$emit('input', this.value);
      } else if (type === 'vertice') {
        const { coordinateX, coordinateY } = value;
        this.onInput(index, { value: { coordinateX, coordinateY, type: 'vertice' } });
      }
    },
    onDelete(type, index) {
      if (type === 'vertice') {
        if (index === 0 && this.value[index + 1]) {
          this.$delete(this.value, index);
          this.$delete(this.value, index);
        } else if (index !== 0 && this.value[index - 1]) {
          this.$delete(this.value, index - 1);
          this.$delete(this.value, index - 1);
        } else {
          this.$delete(this.value, index);
        }
      } else if (type === 'line') {
        if (this.value[index + 1]) {
          this.$delete(this.value, index);
          this.$delete(this.value, index);
        } else {
          this.$delete(this.value, index);
        }
      }
      this.$emit('input', this.value);
    },
  },
};
</script>
